import { render } from "./banktab.vue?vue&type=template&id=2e5c1bf8&scoped=true"
import script from "./banktab.vue?vue&type=script&lang=js"
export * from "./banktab.vue?vue&type=script&lang=js"

import "./banktab.vue?vue&type=style&index=0&id=2e5c1bf8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5c1bf8"]])

export default __exports__